import { Controller } from "@hotwired/stimulus"
import Pagy from "../vendor/pagy.mjs"

export default class extends Controller {
  connect() {
    Pagy.init(this.element)
    this.reinit = () => Pagy.init(this.element)
    document.addEventListener("turbo:morph", this.reinit)
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.reinit)
  }
}
